import React from 'react'
import { Select } from '@ow/comps'

export const customStyles = (controlStyle) => {
  return {
    input: (styles) => ({ ...styles }),
    control: (styles, { isFocused }) => ({
      ...styles,
      ...controlStyle,
      borderBottomLeftRadius: '0',
      borderTopLeftRadius: '0',
      height: '34px',
      minHeight: '34px',
      backgroundColor: '#fff',
      borderColor: isFocused
        ? 'rgb(var(--ow-primary-color)) !important'
        : '#dbdfea',
      boxShadow: isFocused
        ? '0 0 0 3px rgba(var(--ow-primary-color),.10)'
        : 'none',
      ':active': {
        ...styles[':active'],
        borderColor: 'rgb(var(--ow-primary-color))',
        borderBottomLeftRadius: '0px',
      },
      ':hover': {
        ...styles[':hover'],
        borderColor: 'rgb(var(--ow-border-color))',
      },
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      width: '0',
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
    }),
    placeholder: (styles) => ({
      ...styles,
      fontSize: '0.8125rem',
      color: 'var(--ow-color-gray-300)',
    }),
    valueContainer: (styles) => ({
      ...styles,
      flexWrap: 'nowrap',
      padding: '0',
      fontSize: '0.8125rem',
    }),
    menu: (styles) => ({
      ...styles,
      background: '#ffffff',
      borderRadius: '2px',
      boxShadow: '0px 3px 12px 0px rgba(var(--ow-primary-color),0.1)',
      marginTop: '4px',
      marginBottom: '0',
      zIndex: '1000',
    }),
    menuList: (styles) => ({
      ...styles,
      pdddingTop: '0',
    }),
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? '#ebeef2' : '#fff',
        width: '100%',
        color: '#526484',
        padding: '6px 12px',
        borderRadius: '4px',
        fontSize: '0.8125rem',
        ':active': {
          ...styles[':active'],
          backgroundColor: '#ebeef2',
        },
      }
    },
  }
}
const Content = function ({ opts = {}, value, style, onChange }) {
  const options = [
    { slug: 'isNull', label: '为空' },
    { slug: 'notNull', label: '不为空' },
  ]
  const defaultValue = options.filter((item) => {
    return item.slug === value
  })
  console.log('valuevalue', value)
  return (
    <Select
      options={options || []}
      styles={customStyles(style)}
      onChange={(e) => {
        console.log(e)
        const { slug } = e
        onChange(slug)
      }}
      placeholder={opts.hint || `请选择${opts.title}是否为空`}
      value={defaultValue}
      noOptionsMessage={() => '暂无数据'}
    />
  )
}
export default Content
